<header>
	<img src="images/logo.svg" alt="logo" />
</header>

<style>
	header {
		position: absolute;
		left: 0;
		top: 0;
		width: 95%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: center;
		padding: 30px;
		transition: all 0.8s;
	}

	@media (max-width: 768px) {
		header {
			padding: 5px;
		}
	}
</style>
